export default function(ref) {
  return {
    methods: {
      focus() {
        this.$refs[ref].focus();
      }
    }
  };
};



// WEBPACK FOOTER //
// ./~/element-ui/src/mixins/focus.js